import { apiFetch } from './client';
import type { Announcement } from '$lib/types';

export interface AnnouncementBody {
  title: string;
  body: string;
}

export const announcementsApi = {
  list: () => apiFetch<Announcement[]>('/announcements'),
  create: (body: AnnouncementBody) =>
    apiFetch<Announcement>('/announcements', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: AnnouncementBody) =>
    apiFetch<Announcement>(`/announcements/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<null>(`/announcements/${id}`, { method: 'DELETE' })
};
